import { Link } from 'react-router-dom';

const NoticeBar = ({ config }) => {
  if (!config || !config.enabled) return null;

  return (
    <div 
      className="bg-white py-2 overflow-hidden border-b border-slate-100"
      style={{ marginTop: '92px' }}
      data-testid="notice-bar"
    >
      <div className="animate-marquee whitespace-nowrap inline-flex">
        {[...Array(5)].map((_, i) => (
          <Link 
            key={i}
            to={config.link_url} 
            className="text-[#9E1B32] font-medium text-sm hover:underline mx-12"
            data-testid="notice-bar-link"
          >
            {config.text}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NoticeBar;
